<template>
    <div id="ritual">
        <div v-if="isAdmin">
            <as-container gutters="0">
                <!-- Datatable rituels -->
                <div class="grid grid-nogutter mb-3">
                    <div class="flex w-100">
                        <as-title :title="$t('rituals.title')" :size="1"></as-title>
                        <div class="ml-auto">
                            <Button style="width: 200px" :label="$t('rituals.new_ritual_button_label')"
                                class="button-default" @click="showModalRitualForm" />
                        </div>
                    </div>
                </div>
                <ProgressBar v-if="isRitualLoading" mode="indeterminate" style="height: 6px" class="mb-3" />
                <ritual-list v-else :rituals="rituals" :entreprises="entreprises" @onRowClick="showRitualDetails"
                    @editRitual="editRitual" @onDelete="onShowDeleteRitualModal" />
            </as-container>
        </div>

        <as-modal :isVisible="showRitualForm" :isCloseable="true" @onClose="closeModalRitualForm">
            <ritual-form @onClose="closeModalRitualForm" @onSubmit="afterRitualSaved" :ritual="currentRitual"
                :blocs="blocs" :entreprises="entreprises" />
        </as-modal>
        <as-confirm-modal :isVisible="showDeleteRitualModal" :modalMessage="$t('confirm_modal.delete_message')"
            @onConfirm="deleteRitual" @onCancel="deleteRitualCancel" />
        <as-modal :isVisible="showRitualDetailsModal" :isCloseable="true" @onClose="closeRitualDetailsModal">
            <ritual-details :ritualDetails="selectedRitualDetails" @onClose="closeRitualDetailsModal" />
        </as-modal>
    </div>
</template>
<script>
import localeChangeDetectionMixin from "../../mixins/localeChangeDetectionMixins";
import roleMixins from "../../mixins/roleMixins";
import fichiersServiceApi from "../../services/fichiersServiceApi";
import entreprisesServiceApi from "../../services/entreprisesServiceApi";

import { mapGetters } from "vuex";

import AsTitle from "@/components/Elements/AsTitle.vue";
import AsContainer from "@/components/Containers/AsContainer.vue";
import AsModal from "@/components/Modals/AsModal.vue";
import AsConfirmModal from "@/components/Modals/AsConfirmModal.vue";

import RitualList from "@/components/Ritual/RitualList.vue";
import RitualForm from "@/components/Ritual/RitualForm.vue";
import RitualDetails from "@/components/Ritual/RitualDetails.vue";

import Button from "primevue/button";
import ProgressBar from "primevue/progressbar";

import { getBlocs } from "../../services/blocServiceApi";
import { getRituals, deleteRitual } from "../../services/ritualServiceApi";
import apiEventTypes from "../../constantes/apiEventTypes";


export default {
    name: "RitualManagement",
    components: {
        AsTitle,
        AsContainer,
        AsModal,
        AsConfirmModal,
        RitualList,
        RitualForm,
        RitualDetails,
        Button,
        ProgressBar,
    },
    data() {
        return {
            isRitualLoading: true,
            isSending: false,
            showRitualForm: false,
            currentRitual: { id: 0, libelle: '', rituelSujet: [] },
            rituals: [],
            blocs: [],
            entreprises: [],
            showRitualDetailsModal: false,
            selectedRitualDetails: undefined,
            ritualToDeleteId: undefined,
            showDeleteRitualModal: false,
        };
    },
    computed: {
        ...mapGetters({
            user: "getUser",
        }),
    },
    mixins: [localeChangeDetectionMixin, roleMixins, fichiersServiceApi],
    beforeMount() {
        if (!this.isAdmin) {
            this.$router.push("/")
        } else {
            this.fetchData()
        }
    },
    methods: {
        async fetchData() {
            this.entreprises = await entreprisesServiceApi.getEntreprises(true)
            this._fetchBlocs()
            this._fetchRituals()
        },
        showModalRitualForm() {
            this.currentRitual = { id: 0, libelle: '', rituelSujet: [] }
            this.showRitualForm = true
        },
        closeModalRitualForm() {
            this.showRitualForm = false
        },
        closeRitualDetailsModal() {
            this.selectedRitualDetails = undefined
            this.showRitualDetailsModal = false
        },
        onShowDeleteRitualModal(ritualId) {
            this.ritualToDeleteId = ritualId;
            this.showDeleteRitualModal = true;
        },
        deleteRitualCancel() {
            this.ritualToDeleteId = undefined;
            this.showDeleteRitualModal = false;
        },

        async afterRitualSaved(savedRitual, currentFormRitual) {
            this.showRitualForm = false
            const indexOf = this.rituals.findIndex(e => e.id === savedRitual.id)
            indexOf >= 0 ? this.rituals.splice(indexOf, 1, savedRitual) : this.rituals.push(savedRitual)
            this.rituals.sort((a, b) => b.year - a.year || b.month - a.month)
            const savedRitualBlocs = savedRitual.rituelSujet
            currentFormRitual.rituelSujet.forEach(bloc => {
                const filesToUpload = bloc.fichiers.filter(e => !!e.file)
                if (filesToUpload.length) {
                    const ritualBloc = savedRitualBlocs.find(e => e.idSujet == bloc.idSujet)
                    this.uploadFiles(
                        filesToUpload,
                        'rituel-bloc',
                        ritualBloc.id,
                        +this.user.idLdap,
                        () => {
                            this._fetchRituals()
                        }
                    )
                }
            })
        },
        showRitualDetails(ritual) {
            const enterprise = this.entreprises.find(e => e.id === ritual.idEntreprise)
            this.selectedRitualDetails = {
                enterprise,
                ritual
            }
            this.showRitualDetailsModal = true
        },
        async editRitual(ritual) {
            const ritualToEdit = { ...ritual }
            ritualToEdit.rituelSujet = ritualToEdit.rituelSujet.map(e => {
                return {
                    ...e,
                    libelle: e.sujet,
                    selectedSubject: null,
                }
            })
            this.currentRitual = ritualToEdit
            this.showRitualForm = true
        },
        async deleteRitual() {
            if (!this.ritualToDeleteId) { return }
            const result = await deleteRitual(this.ritualToDeleteId);
            if (result) {
                const newList = [...this.rituals];
                const indexOf = newList.findIndex((e) => e.id === this.ritualToDeleteId);
                newList.splice(indexOf, 1);
                this.rituals = newList;
                this.deleteRitualCancel()
                document.dispatchEvent(
                    new CustomEvent(apiEventTypes.API_SUCCESS, {
                        detail: {
                            title: this.$t("popup_messages.success_delete_title"),
                            message: this.$t("popup_messages.success_delete_message"),
                        },
                    })
                );
            }
        },
        async _fetchBlocs() {
            this.isBlocLoading = true
            this.blocs = await getBlocs()
            this.isBlocLoading = false
        },
        async _fetchRituals() {
            this.isRitualLoading = true
            this.rituals = await getRituals()
            this.isRitualLoading = false
        },
    },
};
</script>

<style lang="scss">
#ritual {
    .p-datatable .p-datatable-tbody>tr>td {
        padding: 0rem 1rem !important;
    }

    .as-modal-content-container {
        width: 100vw !important;
        max-width: 100vw !important;
        max-height: 100vh !important;
        height: 100vh !important;

        .content-container {
            width: 100%;
            max-width: 100%;
            height: 100%;

            .as-modal-content {
                border-radius: 0;
                min-height: 100%;
            }
        }
    }
}
</style>
